/* LSC custom cart drawer (replaces Supercart). Test theme "Cart rebuild - TEST" only. Built 2026-10-06.
   Ajax Cart API: /cart.js, /cart/add.js, /cart/change.js, /cart/update.js */
(function () {
  'use strict';
  var root = document.getElementById('lsc-cart');
  var cfgEl = document.getElementById('lsc-cart-config');
  if (!root || !cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);
  // full cart page (/cart?view=full, templates/cart.full.json): the same cart is mounted inline into this slot
  var pageSlot = document.getElementById('lsc-cart-page-slot'), PAGE_MODE = !!pageSlot;
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var state = { cart: null, addonProducts: {}, openDesc: {}, upsellsLoaded: false, dirtyOnCartPage: false, syncGuard: 0 };
  var LS_KEY = 'lsc_cold_weather_v1';
  var PREVIEW = true; // shipping rate checker + legality bar ON for customers (2026-10-09). Rollback: v2.lsc-cart.js

  /* Cancellation fee copy (cleared by Christian 2026-10-09). Edit both strings here only. */
  var FEE_TXT = {
    legalAppend: ' If we have to cancel the order because of it, a 15% cancellation fee may apply.',
    disclaimer: 'Cancellations may be subject to a 15% cancellation fee.'
  };

  var TXT = {
    cwSub: "Your fish travel overnight. When it's cold anywhere along the way, we add heat packs and extra insulation to keep their water in a safe range.",
    cwNote: "We check the coldest low at our shipping origin, the overnight carrier hub and your address. We go one level higher if your daytime high stays under 50°F. Below 32°F, above 100°F, or during severe weather, we hold your order until it's safe to ship. If the forecast changes, we'll adjust your level and refund or invoice the difference.",
    levels: [
      { level: 0, name: 'None needed', cond: 'Lows of 50°F or warmer all along the route.' },
      { level: 1, name: 'Level 1', cond: 'Lows of 44–49°F.' },
      { level: 2, name: 'Level 2', cond: 'Lows of 38–43°F.' },
      { level: 3, name: 'Level 3', cond: 'Lows of 32–37°F.' }
    ],
    kit: 'Extra Acclimation Kit (one free kit already comes with every order)',
    short: { '7day': 'Up to $1,000 for 7 days after arrival', '30day': 'Up to $1,000 for 30 days after arrival', 'donation': 'Supports a 501c3 pet fish rescue' },
    protectionDesc: 'We are very confident in the health of our livestock and believe that they will continue to thrive in your care, however things don\'t always work out the way they should. We are offering protection on your new livestock purchase up to $1,000 with our Livestock Protection Program. If you lose your new fish in the first 7 or 30 days after arrival, simply <a href="https://lonestarrareexoticfish.com/pages/insurance-claim-submission-form">submit a claim</a> and we will refund the full purchase price of your fish, even if it\'s your fault! We won\'t ask any questions about your set up, experience level, water parameters, etc. All we ask for is photographic proof that the fish is not alive. You must keep the remains until the claim is resolved, meaning the protection will not apply if lost to something like being consumed by tank-mates. Void if the fish has been visibly damaged by other fish. Protection fee is non-refundable.',
    donationDesc: 'Nothing they do is small and everything they do helps the pet fish hobby.<br><br>The Ohio Fish Rescue was created to take in pet fish in-need and either find them new homes or keep them in their huge in-home aquatic paradise. They have just reached over 200,000 gallons of loving aquarium and pool/pond space, and they like to say that the occupants there need every cubic inch of it! The fish are huge, the tanks are huge and their love for the fish is huge too!<br><br>The work they do is both invaluable to the hobby, as well as very expensive and laborious to manage. These great folks have made it their lives mission to help advance the hobby in so many ways. Help us help them with a small donation today, and be sure to follow them on social media to keep up with the work they\'re doing!<br><br>The Ohio Fish Rescue, LLC is a 501c3 not-for-profit organization dedicated to saving unwanted pet fish and other aquatic species.'
  };
  var POINTS = { origin: { name: 'Livingston, TX 77351', lat: 30.6829, lon: -94.8976 }, hub: { name: 'Louisville, KY (UPS hub)', lat: 38.1901, lon: -85.7519 } };

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var amt = (Number(cents || 0) / 100);
    var f = cfg.moneyFormat || '${{amount}}';
    var withC = amt.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(amt)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amt.toFixed(2).replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, withC).replace(/<[^>]*>/g, '');
  }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function api(url, body, isForm) {
    var opts = { method: body ? 'POST' : 'GET', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' };
    if (body) { if (isForm) opts.body = body; else { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); } }
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || ('Request failed (' + r.status + ')')); e.status = r.status; throw e; }
        return j;
      });
    });
  }
  function showErr(msg) { var el = $('[data-lsc-err]'); el.textContent = msg || ''; if (msg) setTimeout(function () { if (el.textContent === msg) el.textContent = ''; }, 7000); }
  function busy(on) { $('.lsc-scroll').classList.toggle('lsc-busy', !!on); }

  /* ---------- add-on / managed detection ---------- */
  function coldVariantIds() { return (cfg.coldLevels || []).map(function (l) { return l.variantId; }).filter(Boolean); }
  function managedHandles() { return (cfg.addons || []).map(function (a) { return a.handle; }); }
  function isManaged(item) {
    return managedHandles().indexOf(item.handle) > -1 || coldVariantIds().indexOf(item.variant_id) > -1 || (cfg.kit && cfg.kit.variantId && item.variant_id === cfg.kit.variantId);
  }
  function isService(item) { return item.product_type === 'Shop Service' || isManaged(item); }
  function livestockSubtotal(cart) { return cart.items.filter(function (i) { return !isService(i); }).reduce(function (s, i) { return s + i.final_line_price; }, 0); }
  function visibleCount(cart) { return cart.items.filter(function (i) { return !isManaged(i); }).reduce(function (s, i) { return s + i.quantity; }, 0); }

  function loadAddonProducts() {
    return Promise.all((cfg.addons || []).map(function (a) {
      if (state.addonProducts[a.key]) return null;
      return api('/products/' + encodeURIComponent(a.handle) + '.js').then(function (p) {
        p.variants.sort(function (x, y) { return x.price - y.price; });
        state.addonProducts[a.key] = p;
      }).catch(function () { state.addonProducts[a.key] = null; });
    }));
  }
  /* Supercart pricing: fixed fee + percent of livestock subtotal, rounded UP to the next price-tier variant */
  function desiredVariant(addon, cart) {
    var p = state.addonProducts[addon.key];
    if (!p) return null;
    var target = addon.fixed + (addon.percent / 100) * livestockSubtotal(cart);
    var avail = p.variants.filter(function (v) { return v.available; });
    for (var i = 0; i < avail.length; i++) if (avail[i].price >= Math.round(target) - 0.5) return avail[i];
    return avail[avail.length - 1] || null;
  }
  function addonLine(addon, cart) { return cart.items.filter(function (i) { return i.handle === addon.handle; })[0] || null; }

  /* ---------- cart IO ---------- */
  function fetchCart() { return api('/cart.js').then(function (c) { state.cart = c; return c; }); }
  function syncAddons(cart) {
    // keep protection price tier in step with the livestock subtotal; drop add-ons if no livestock left
    if (state.syncGuard > 3) return Promise.resolve(cart);
    var updates = {}, need = false;
    var hasLivestock = livestockSubtotal(cart) > 0;
    (cfg.addons || []).forEach(function (a) {
      var line = addonLine(a, cart); if (!line) return;
      if (!hasLivestock) { updates[line.key] = 0; need = true; return; }
      if (a.key === 'donation') return; // donation: $1 variant x quantity set by the stepper, never re-tiered
      var want = desiredVariant(a, cart);
      if (want && (line.variant_id !== want.id || line.quantity !== 1)) { updates[line.key] = 0; need = true; updates['__add_' + a.key] = want.id; }
    });
    if (!need) return Promise.resolve(cart);
    state.syncGuard++;
    var adds = [], ups = {};
    Object.keys(updates).forEach(function (k) { if (k.indexOf('__add_') === 0) adds.push({ id: updates[k], quantity: 1 }); else ups[k] = updates[k]; });
    // keys can't be mixed with ids in /cart/update.js, so remove first then add
    var p = api('/cart/update.js', { updates: ups });
    if (adds.length) p = p.then(function () { return api('/cart/add.js', { items: adds }); });
    return p.then(fetchCart).then(syncAddons);
  }
  function refresh() {
    busy(true);
    return loadAddonProducts().then(fetchCart).then(syncAddons).then(function (c) { state.syncGuard = 0; render(c); busy(false); return c; })
      .catch(function (e) { busy(false); showErr('Sorry, we couldn\'t load your cart. Please try again.'); console.warn('[lsc-cart]', e); });
  }
  function mutate(promise) {
    busy(true); showErr('');
    if (cfg.isCartPage) state.dirtyOnCartPage = true;
    return promise.then(refresh).catch(function (e) { busy(false); showErr(e.message || 'Something went wrong. Please try again.'); return refresh(); });
  }
  function changeLine(key, qty) { return mutate(api('/cart/change.js', { id: key, quantity: qty })); }

  /* ---------- render ---------- */
  function render(cart) {
    $('[data-lsc-loading]').hidden = true;
    var count = visibleCount(cart);
    $('[data-lsc-count]').textContent = '· ' + count;
    document.querySelectorAll('.header__cart-count, [data-cart-count]').forEach(function (el) { el.textContent = count; });
    renderFreeShipping(cart);
    var empty = cart.items.length === 0;
    $('[data-lsc-empty]').hidden = !empty;
    $('[data-lsc-full]').hidden = empty;
    if (empty) return;
    renderItems(cart);
    renderCold(cart);
    renderAddons(cart);
    renderKit(cart);
    renderSummary(cart);
    if (PREVIEW) renderShipLegal(cart);
    ensureFeeUI();
    if (!state.upsellsLoaded) renderUpsells(cart);
  }
  var FS_TRUCK = '<svg class="lsc-fs__icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path fill="currentColor" d="M3 5.5A1.5 1.5 0 0 1 4.5 4h9A1.5 1.5 0 0 1 15 5.5V7h2.6c.5 0 .97.25 1.25.66l2.4 3.5c.17.25.25.54.25.84V16a1.5 1.5 0 0 1-1.5 1.5h-.55a2.75 2.75 0 0 1-5.4 0h-4.1a2.75 2.75 0 0 1-5.4 0H4.5A1.5 1.5 0 0 1 3 16V5.5Zm12 3V12h4.63l-2-3.5H15ZM7.25 16a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm9.5 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"/></svg>';
  var FS_CHECK = '<svg class="lsc-fs__icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10" fill="currentColor"/><path d="M7.5 12.5l3 3 6-6.5" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  // Alaska free shipping starts at $1,000 (2026-10-18): use cfg.freeShippingThresholdAK when the cart's ZIP (rate checker, cold weather box) is an Alaska ZIP.
  function fsThreshold(cart) {
    var base = cfg.freeShippingThreshold || 50000;
    try {
      var z = state.ship && /^\d{5}$/.test(state.ship.zip || '') ? state.ship.zip : lsGet(SHIP_LS);
      if (!/^\d{5}$/.test(z || '') && cart) z = coldZip(cart);
      var st = zipState(z);
      return st && st.code === 'AK' && cfg.freeShippingThresholdAK ? cfg.freeShippingThresholdAK : base;
    } catch (e) { return base; }
  }
  function renderFreeShipping(cart) {
    var th = fsThreshold(cart), total = cart.total_price, el = $('[data-lsc-fs]');
    if (!cart.items.length) { el.innerHTML = ''; el.className = 'lsc-fs'; state.fsPct = 0; return; }
    var pct = Math.min(100, Math.floor(total / th * 100));
    var done = total >= th, wasDone = !!state.fsDone, from = state.fsPct == null ? 0 : state.fsPct;
    var msg = done
      ? FS_CHECK + '<span><strong>Free Shipping</strong></span>'
      : FS_TRUCK + '<span>You\'re <strong>' + esc(money(th - total)) + '</strong> away from <strong>FREE shipping</strong></span>';
    el.className = 'lsc-fs' + (done ? ' lsc-fs--done' + (wasDone ? '' : ' lsc-fs--pop') : '');
    el.innerHTML = '<div class="lsc-fs__msg" role="status">' + msg + '</div>' +
      '<div class="lsc-fs__track" role="progressbar" aria-label="Progress to free shipping" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><div class="lsc-fs__fill" style="width:' + from + '%"></div></div>';
    var fill = el.querySelector('.lsc-fs__fill');
    requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = pct + '%'; }); });
    state.fsPct = pct; state.fsDone = done;
  }

  function renderItems(cart) {
    var html = cart.items.filter(function (i) { return !isManaged(i); }).map(function (i) {
      var variant = i.variant_title && i.variant_title !== 'Default Title' ? '<div class="lsc-item__variant">' + esc(i.variant_title) + '</div>' : '';
      var props = '';
      if (i.properties) Object.keys(i.properties).forEach(function (k) { var v = i.properties[k]; if (k.charAt(0) !== '_' && v) props += '<div class="lsc-item__props">' + esc(k) + ': ' + esc(v) + '</div>'; });
      var compare = i.original_line_price > i.final_line_price ? '<span class="lsc-item__compare">' + money(i.original_line_price) + '</span>' : '';
      return '<li class="lsc-item" data-key="' + esc(i.key) + '">' +
        (i.image ? '<img class="lsc-item__img" src="' + esc(img(i.image, 160)) + '" alt="" loading="lazy">' : '<span class="lsc-item__img"></span>') +
        '<div><a class="lsc-item__title" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' + variant + props + '</div>' +
        '<div class="lsc-item__price">' + compare + money(i.final_line_price) + '</div>' +
        '<div class="lsc-item__controls"><div class="lsc-qty"><button type="button" data-qty="-1" aria-label="Decrease quantity">&minus;</button><input type="number" min="0" value="' + i.quantity + '" aria-label="Quantity" data-qty-input><button type="button" data-qty="1" aria-label="Increase quantity">+</button></div>' +
        '<button type="button" class="lsc-remove" data-remove>Remove</button></div></li>';
    }).join('');
    $('[data-lsc-items]').innerHTML = html;
  }

  /* cold weather */
  function loadPred() { try { return JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { return null; } }
  function savePred(p) { try { localStorage.setItem(LS_KEY, JSON.stringify(p)); } catch (e) {} }
  function levelName(n) { var l = (cfg.coldLevels || [])[n - 1]; return n === 0 ? 'None needed' : ((l && l.label) || ('Level ' + n)); }
  function levelPriceText(n) { if (n === 0) return 'Free'; var l = cfg.coldLevels[n - 1]; return l && l.variantId && l.price != null ? money(l.price) : '$_.__'; }
  function levelPriced(n) { if (n === 0) return true; var l = cfg.coldLevels[n - 1]; return !!(l && l.variantId && l.price != null); }
  function coldLevelInCart(cart) {
    for (var n = 1; n <= 3; n++) { var l = cfg.coldLevels[n - 1]; if (l && l.variantId && cart.items.some(function (i) { return i.variant_id === l.variantId; })) return n; }
    return null;
  }
  function renderCold(cart) {
    var pred = loadPred();
    var attrZip = cart.attributes && cart.attributes['Shipping ZIP'];
    if (pred && attrZip && pred.zip !== attrZip) pred = null;
    var inCart = coldLevelInCart(cart);
    var sel = inCart != null ? inCart : (pred && pred.selected != null ? pred.selected : (pred && pred.level != null ? pred.level : null));
    var showPick = !!pred || inCart != null;
    var infoBtn = '<button type="button" class="lsc-info" data-pop="cw" aria-label="Cold weather packing info">Info</button>';
    if (!showPick) {
      $('[data-lsc-cw]').innerHTML = '<div class="lsc-row__line"><span class="lsc-row__name">Cold weather packing</span>' + infoBtn +
        '<form class="lsc-cw__zip" data-cw-form novalidate><input type="text" inputmode="numeric" pattern="[0-9]{5}" maxlength="5" placeholder="ZIP" aria-label="Shipping ZIP code" value="' + esc(attrZip || (PREVIEW ? lsGet(SHIP_LS) : '') || '') + '" data-cw-zip><button type="submit" class="lsc-btn lsc-btn--secondary lsc-btn--tiny" data-cw-check>Check</button></form></div>';
      return;
    }
    var opts = TXT.levels.map(function (l) {
      var rec = pred && !pred.hold && !pred.error && pred.level === l.level ? ' · rec.' : '';
      return '<option value="' + l.level + '"' + (sel === l.level ? ' selected' : '') + '>' + esc(levelName(l.level)) + ' · ' + levelPriceText(l.level) + rec + '</option>';
    }).join('');
    var soon = sel != null && !levelPriced(sel) ? '<div class="lsc-cw__soon">Pricing coming soon — nothing added yet</div>' : '';
    var label = (pred && pred.hold) ? 'Hold until safe' : (pred && pred.error) ? 'Choose a level' : 'Cold weather packing';
    $('[data-lsc-cw]').innerHTML =
      '<div class="lsc-row__line"><span class="lsc-row__name">' + esc(label) + '</span>' + infoBtn +
      '<select class="lsc-select" aria-label="Cold weather level" data-cw-select>' + (sel == null ? '<option value="" selected disabled>Choose…</option>' : '') + opts + '</select></div>' + soon;
  }

  function ctParts(d) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23', weekday: 'short' });
    var o = {}; f.formatToParts(d).forEach(function (p) { o[p.type] = p.value; }); return o;
  }
  function shipDay(now) {
    var p = ctParts(now || new Date());
    var base = new Date(Date.UTC(+p.year, +p.month - 1, +p.day, 12)); // CT calendar date at noon UTC
    var hour = +p.hour;
    for (var i = 0; i < 8; i++) {
      var d = new Date(base.getTime() + i * 86400000), wd = d.getUTCDay();
      if (wd >= 1 && wd <= 3 && (i > 0 || hour < 12)) return d;
    }
  }
  function ymd(d) { return d.toISOString().slice(0, 10); }
  function label(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }); }
  function predictLevel(origin, hub, dest) {
    // origin: ship day; hub: lower of ship-day and delivery-day min; destination: delivery day
    var lows = [origin.min[0], Math.min(hub.min[0], hub.min[1]), dest.min[1]];
    var highs = [origin.max[0], hub.max[0], hub.max[1], dest.max[1]];
    if (lows.concat(highs).some(function (v) { return v == null || isNaN(v); })) throw new Error('incomplete forecast');
    var coldest = Math.round(Math.min.apply(null, lows));
    var hottest = Math.max.apply(null, highs);
    if (hottest > 100 || coldest < 32) return { hold: true, coldest: coldest, hottest: hottest };
    var level = coldest >= 50 ? 0 : coldest >= 44 ? 1 : coldest >= 38 ? 2 : 3;
    var bumped = dest.max[1] < 50 && level < 3;
    if (bumped) level++;
    return { hold: false, level: level, coldest: coldest, hottest: hottest, bumped: bumped };
  }
  function checkZip(zip) {
    var ship = shipDay(), deliv = new Date(ship.getTime() + 86400000);
    var base = { zip: zip, ship: ymd(ship), shipLabel: label(ship), checkedAt: new Date().toISOString() };
    return fetch('https://api.zippopotam.us/us/' + zip).then(function (r) {
      if (r.status === 404) throw { user: 'We couldn\'t find ZIP ' + zip + '. Please check it and try again.' };
      if (!r.ok) throw new Error('zip ' + r.status);
      return r.json();
    }).then(function (z) {
      var pl = z.places && z.places[0]; if (!pl) throw { user: 'We couldn\'t find ZIP ' + zip + '. Please check it and try again.' };
      base.place = pl['place name'] + ', ' + pl['state abbreviation'];
      var pts = [POINTS.origin, POINTS.hub, { lat: +pl.latitude, lon: +pl.longitude }];
      var url = 'https://api.open-meteo.com/v1/forecast?latitude=' + pts.map(function (p) { return p.lat; }).join(',') + '&longitude=' + pts.map(function (p) { return p.lon; }).join(',') +
        '&daily=temperature_2m_min,temperature_2m_max&temperature_unit=fahrenheit&timezone=auto&start_date=' + ymd(ship) + '&end_date=' + ymd(deliv);
      return fetch(url).then(function (r) { if (!r.ok) throw new Error('weather ' + r.status); return r.json(); });
    }).then(function (w) {
      if (!Array.isArray(w) || w.length !== 3) throw new Error('weather shape');
      var d = w.map(function (x) { return { min: x.daily.temperature_2m_min, max: x.daily.temperature_2m_max }; });
      var r = predictLevel(d[0], d[1], d[2]);
      return Object.assign(base, r, { temps: { origin: d[0], hub: d[1], dest: d[2] } });
    }).catch(function (e) {
      console.warn('[lsc-cart] cold weather check failed', e);
      return Object.assign(base, { error: (e && e.user) || 'We couldn\'t load the forecast right now. Please choose a level using the guide below, and we\'ll confirm it when we schedule your shipment.', level: null });
    });
  }
  function applyColdSelection(level) {
    // replace any cold-weather line with the chosen level (only when that level is priced)
    var cart = state.cart, ups = {}, n;
    for (n = 1; n <= 3; n++) { var l = cfg.coldLevels[n - 1]; if (!l || !l.variantId) continue; cart.items.forEach(function (i) { if (i.variant_id === l.variantId && n !== level) ups[i.key] = 0; }); }
    var p = Object.keys(ups).length ? api('/cart/update.js', { updates: ups }) : Promise.resolve();
    if (level > 0 && levelPriced(level) && coldLevelInCart(cart) !== level) p = p.then(function () { return api('/cart/add.js', { items: [{ id: cfg.coldLevels[level - 1].variantId, quantity: 1 }] }); });
    p = p.then(function () { return api('/cart/update.js', { attributes: { 'Selected cold weather level': levelName(level) } }); });
    return mutate(p);
  }

  function renderAddons(cart) {
    var html = (cfg.addons || []).map(function (a) {
      var p = state.addonProducts[a.key];
      if (!p) return '';
      var line = addonLine(a, cart);
      if (a.key === 'donation') return donationRow(a, cart);
      var v = line ? { price: line.final_line_price } : desiredVariant(a, cart);
      return '<div class="lsc-row" data-addon="' + a.key + '"><div class="lsc-row__line">' +
        '<span class="lsc-row__name">' + esc(a.title) + '</span>' +
        '<button type="button" class="lsc-info" data-pop="addon:' + a.key + '">Info</button>' +
        '<div class="lsc-row__end"><span class="lsc-row__price">' + (v ? money(v.price) : '') + '</span>' +
        '<label class="lsc-toggle"><input type="checkbox" data-addon-toggle="' + a.key + '"' + (line ? ' checked' : '') + ' aria-label="Add ' + esc(a.title) + '"><span></span></label></div>' +
        '</div></div>';
    }).join('');
    $('[data-lsc-addons]').innerHTML = html;
  }

  /* donation: stepper/typed amount of the $1 variant, whole dollars 0-999 (typed values above 999 clamp to 999) */
  var DON_MAX = 999;
  function donationVariant() {
    var p = state.addonProducts.donation; if (!p) return null;
    return p.variants.filter(function (v) { return v.price === 100 && v.available; })[0] || null;
  }
  function donationLine(cart) { var v = donationVariant(); return v ? cart.items.filter(function (i) { return i.variant_id === v.id; })[0] || null : null; }
  function donationRow(a, cart) {
    var v = donationVariant(); if (!v) return '';
    var line = donationLine(cart), qty = line ? line.quantity : 0;
    return '<div class="lsc-row" data-addon="donation"><div class="lsc-row__line">' +
      '<span class="lsc-row__name">' + esc(a.title) + '</span>' +
      '<button type="button" class="lsc-info" data-pop="addon:donation">Info</button>' +
      '<div class="lsc-row__end"><span class="lsc-row__price" data-don-amount>' + (qty ? money(line.final_line_price) : money(0)) + '</span>' +
      '<div class="lsc-qty lsc-qty--sm" data-don><button type="button" data-don-qty="-1" aria-label="Donate $1 less">&minus;</button><input type="number" min="0" max="' + DON_MAX + '" step="1" inputmode="numeric" value="' + qty + '" aria-label="Donation in dollars" data-don-input style="width:40px"><button type="button" data-don-qty="1" aria-label="Donate $1 more"' + (qty >= DON_MAX ? ' disabled style="opacity:.35;cursor:not-allowed"' : '') + '>+</button></div></div>' +
      '</div></div>';
  }
  function donationStep(delta) { var line = state.cart && donationLine(state.cart); return donationSet((line ? line.quantity : 0) + delta); }
  function donationSet(want) {
    var v = donationVariant(); if (!v || !state.cart) return;
    var line = donationLine(state.cart), q = Math.floor(Number(want));
    if (!isFinite(q) || q < 0) q = 0;
    var capped = q > DON_MAX; if (capped) q = DON_MAX;
    var done = line ? (q === line.quantity ? render(state.cart) : changeLine(line.key, q)) : (q > 0 ? mutate(api('/cart/add.js', { items: [{ id: v.id, quantity: q }] })) : render(state.cart));
    if (capped) return Promise.resolve(done).then(function () { showErr('Online donations are limited to $' + DON_MAX + '. Please contact us for a larger gift.'); });
    return done;
  }

  function toggleAddon(key, on) {
    var a = cfg.addons.filter(function (x) { return x.key === key; })[0];
    var cart = state.cart, line = addonLine(a, cart);
    if (on && !line) { var v = desiredVariant(a, cart); if (!v) return showErr('That option is unavailable right now.'); return mutate(api('/cart/add.js', { items: [{ id: v.id, quantity: 1 }] })); }
    if (!on && line) return changeLine(line.key, 0);
  }
  function renderKit(cart) {
    var k = cfg.kit || {}, ready = !!(k.variantId && k.price != null);
    var line = ready ? cart.items.filter(function (i) { return i.variant_id === k.variantId; })[0] : null;
    var qty = line ? line.quantity : 0;
    $('[data-lsc-kit]').innerHTML = '<div class="lsc-row__line">' +
      '<span class="lsc-row__name">Extra Acclimation Kit</span>' +
      '<button type="button" class="lsc-info" data-pop="kit">Info</button>' +
      '<div class="lsc-row__end"><span class="lsc-row__price" data-kit-amount>' + (ready ? money(line ? line.final_line_price : 0) : '$_.__') + '</span>' +
      '<div class="lsc-qty lsc-qty--sm' + (ready ? '' : ' is-disabled') + '" data-kit><button type="button" data-kit-qty="-1" aria-label="Fewer kits"' + (ready ? '' : ' disabled') + '>&minus;</button><input type="number" min="0" value="' + qty + '" aria-label="Extra kits" readonly><button type="button" data-kit-qty="1" aria-label="More kits"' + (ready ? '' : ' disabled') + '>+</button></div></div></div>';
  }

  function kitStep(delta) {
    var k = cfg.kit; if (!k || !k.variantId || k.price == null) return;
    var line = state.cart.items.filter(function (i) { return i.variant_id === k.variantId; })[0];
    if (line) return changeLine(line.key, Math.max(0, line.quantity + delta));
    if (delta > 0) return mutate(api('/cart/add.js', { items: [{ id: k.variantId, quantity: 1 }] }));
  }

  function renderSummary(cart) {
    $('[data-lsc-total]').textContent = money(cart.total_price);
    var codes = cart.discount_codes || [];
    $('[data-lsc-discount-codes]').innerHTML = codes.map(function (c) {
      return '<span class="lsc-code' + (c.applicable ? '' : ' lsc-code--bad') + '">' + esc(c.code) + (c.applicable ? '' : ' (not applicable)') + '<button type="button" data-code-remove="' + esc(c.code) + '" aria-label="Remove code">&#10005;</button></span>';
    }).join('');
    var ta = $('[data-lsc-note-text]');
    if (document.activeElement !== ta) ta.value = cart.note || '';
    $('[data-lsc-toggle="note"]').textContent = cart.note ? 'Edit note' : 'Note';
  }
  function setDiscounts(list) {
    return api('/cart/update.js', { discount: list.join(',') });
  }
  function saveNote() {
    var ta = $('[data-lsc-note-text]'), st = $('[data-lsc-note-status]');
    if (!state.cart || ta.value === (state.cart.note || '')) return Promise.resolve();
    st.textContent = 'Saving…';
    return api('/cart/update.js', { note: ta.value }).then(function (c) { state.cart = c; st.textContent = 'Saved'; $('[data-lsc-toggle="note"]').textContent = c.note ? 'Edit note' : 'Note'; return true; })
      .catch(function () { st.textContent = 'Couldn\'t save. Please try again.'; return false; });
  }

  /* upsell (single small carousel) */
  function renderUpsells(cart) {
    state.upsellsLoaded = true;
    var u = (cfg.upsells || [])[0]; if (!u) return;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    api('/collections/' + encodeURIComponent(u.collection) + '/products.json?limit=60').then(function (d) {
      var list = (d.products || []).filter(function (p) {
        return p.images && p.images.length && (p.tags || []).indexOf('hidden-addon') === -1 && p.product_type !== 'Shop Service' && inCart.indexOf(p.id) === -1 && p.variants.some(function (v) { return v.available; });
      }).slice(0, u.limit || 12);
      if (!list.length) return;
      var cards = list.map(function (p) {
        var vs = p.variants.filter(function (v) { return v.available; });
        var sel = vs.length > 1 ? '<select class="lsc-card__sel" data-ups-variant aria-label="Choose option">' + vs.map(function (v) { return '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + '</option>'; }).join('') + '</select>' : '<input type="hidden" data-ups-variant value="' + vs[0].id + '"><span class="lsc-card__sel lsc-card__sel--ph" aria-hidden="true"></span>';
        var im = '<img class="lsc-card__img" src="' + esc(img(p.images[0].src, 300)) + '" alt="" loading="lazy">';
        return '<div class="lsc-card">' + im + '<a class="lsc-card__title" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a><div class="lsc-card__price" data-ups-price>' + money(Math.round(parseFloat(vs[0].price) * 100)) + '</div>' + sel + '<button type="button" class="lsc-card__btn" data-ups-add>Add to cart</button></div>';
      }).join('');
      $('[data-lsc-upsells]').innerHTML = '<div class="lsc-ups"><div class="lsc-ups__head"><p class="lsc-ups__title">' + esc(u.title) + '</p><div class="lsc-ups__nav"><button type="button" data-ups-nav="-1" aria-label="Previous">&#8249;</button><button type="button" data-ups-nav="1" aria-label="Next">&#8250;</button></div></div><div class="lsc-ups__track" data-ups-track>' + cards + '</div></div>';
    }).catch(function (e) { console.warn('[lsc-cart] upsells failed', e); });
  }


  function popoverHtml(kind) {
    if (kind === 'cw') {
      var rows = TXT.levels.map(function (l) { return '<tr><td>' + esc(levelName(l.level)) + '</td><td>' + esc(l.cond) + '</td></tr>'; }).join('');
      var pred = loadPred();
      var extra = '';
      if (pred && !pred.error && !pred.hold && pred.zip) extra = '<p>Last check: ZIP ' + esc(pred.zip) + ' for ship day ' + esc(pred.shipLabel) + ' → ' + esc(levelName(pred.level)) + '.</p>';
      else if (pred && pred.hold) extra = '<p>Last check: ZIP ' + esc(pred.zip) + ' — we\'ll hold until it\'s safe to ship.</p>';
      return '<h4>Cold weather packing</h4><p>' + esc(TXT.cwSub) + '</p><table>' + rows + '</table><p>' + esc(TXT.cwNote) + '</p>' + extra +
        '<form class="lsc-cw__zip" data-cw-form novalidate style="margin-top:10px"><input type="text" inputmode="numeric" pattern="[0-9]{5}" maxlength="5" placeholder="ZIP" aria-label="Shipping ZIP code" value="' + esc((pred && pred.zip) || '') + '" data-cw-zip><button type="submit" class="lsc-btn lsc-btn--secondary lsc-btn--tiny" data-cw-check>Recheck</button></form>';
    }
    if (kind === 'kit') return '<h4>Extra Acclimation Kit</h4><p>One free kit already comes with every order. Use the stepper if you need extras for multiple tanks.</p>' + (cfg.kit && cfg.kit.variantId ? '' : '<p>Pricing coming soon.</p>');
    if (kind.indexOf('addon:') === 0) {
      var key = kind.slice(6);
      var a = (cfg.addons || []).filter(function (x) { return x.key === key; })[0];
      if (!a) return '';
      var body = a.info === 'donation' ? TXT.donationDesc : (esc(a.subtitle) + '<br><br>' + TXT.protectionDesc);
      return '<h4>' + esc(a.title) + '</h4><div>' + body + '</div>';
    }
    return '';
  }
  function openPop(kind) {
    var html = popoverHtml(kind); if (!html) return;
    $('[data-lsc-pop-body]').innerHTML = html;
    $('[data-lsc-pop]').hidden = false;
  }
  function closePop() { $('[data-lsc-pop]').hidden = true; }

  /* ---------- PREVIEW ONLY (built 2026-10-09): "Check Shipping Rates" + state legality warning ----------
     Runs only when the page was opened with ?lsc_preview=1 (kept for the tab in sessionStorage; ?lsc_preview=0 clears it).
     Without the flag none of this runs and the cart behaves exactly as before.
     Legality data: assets/lsc-legality.json (built from sections/fish-legality-map.liquid; see the build notes). */
  var SHIP_LS = 'lsc_ship_zip_v1';
  // Yellow ("check with the state") handling. The legality asset carries the switch as L.ym (set in the build, rules_r6g.py YELLOW_MODE);
  // this is only the fallback for an older asset without it. 'note' = soft note, no hold; 'red' = same as red; 'off' = ignore yellow.
  var LEGAL_YELLOW = 'note';
  var US = { AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California', CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia', FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming' };
  // first three ZIP digits -> state (USPS prefix ranges; territories and military ZIPs are left out)
  var ZIP3 = [[5,5,'NY'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],[50,54,'VT'],[55,55,'MA'],[56,59,'VT'],[60,69,'CT'],[70,89,'NJ'],[100,149,'NY'],[150,196,'PA'],[197,199,'DE'],[200,200,'DC'],[201,201,'VA'],[202,205,'DC'],[206,219,'MD'],[220,246,'VA'],[247,268,'WV'],[270,289,'NC'],[290,299,'SC'],[300,319,'GA'],[320,339,'FL'],[341,349,'FL'],[350,369,'AL'],[370,385,'TN'],[386,397,'MS'],[398,399,'GA'],[400,427,'KY'],[430,459,'OH'],[460,479,'IN'],[480,499,'MI'],[500,528,'IA'],[530,549,'WI'],[550,567,'MN'],[569,569,'DC'],[570,577,'SD'],[580,588,'ND'],[590,599,'MT'],[600,629,'IL'],[630,658,'MO'],[660,679,'KS'],[680,693,'NE'],[700,714,'LA'],[716,729,'AR'],[730,732,'OK'],[733,733,'TX'],[734,749,'OK'],[750,799,'TX'],[800,816,'CO'],[820,831,'WY'],[832,838,'ID'],[840,847,'UT'],[850,865,'AZ'],[870,884,'NM'],[885,885,'TX'],[889,898,'NV'],[900,961,'CA'],[967,968,'HI'],[970,979,'OR'],[980,994,'WA'],[995,999,'AK']];
  function zipState(zip) {
    if (!/^\d{5}$/.test(zip || '')) return null;
    var p = +zip.slice(0, 3);
    for (var i = 0; i < ZIP3.length; i++) if (p >= ZIP3[i][0] && p <= ZIP3[i][1]) return { code: ZIP3[i][2], name: US[ZIP3[i][2]] };
    return null;
  }
  function lsGet(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function cartSig(cart) { return cart.items.map(function (i) { return i.variant_id + 'x' + i.quantity; }).join(',') + '|' + cart.total_price; }
  state.ship = { zip: '', status: 'idle', rates: null, msg: '', sig: '', auto: false, seq: 0 };

  function coldZip(cart) { var a = cart.attributes && cart.attributes['Shipping ZIP']; var p = loadPred(); return (a && /^\d{5}$/.test(a)) ? a : (p && p.zip) || ''; }
  function ensureShipUI() {
    if ($('[data-lsc-ship]')) return;
    var form = $('[data-lsc-checkout-form]'); if (!form) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = '<div class="lsc-ship" data-lsc-ship><div class="lsc-ship__line"><span class="lsc-ship__name">Check shipping rates</span>' +
      '<form class="lsc-ship__form" data-ship-form novalidate><input type="text" inputmode="numeric" autocomplete="postal-code" pattern="[0-9]{5}" maxlength="5" placeholder="ZIP" aria-label="ZIP code for shipping rates" data-ship-zip>' +
      '<button type="submit" class="lsc-btn lsc-btn--secondary lsc-btn--tiny" data-ship-check>Check</button></form></div>' +
      '<div class="lsc-ship__out" data-ship-out aria-live="polite"></div></div>' +
      '<div class="lsc-legal" data-lsc-legal role="alert" hidden></div>';
    while (wrap.firstChild) form.parentNode.insertBefore(wrap.firstChild, form);
  }
  function ensureFeeUI() {
    var form = $('[data-lsc-checkout-form]'); if (!form) return;
    var el = $('[data-lsc-fee]');
    if (!el) { el = document.createElement('p'); el.className = 'lsc-fee'; el.setAttribute('data-lsc-fee', ''); el.textContent = FEE_TXT.disclaimer; }
    if (el.nextElementSibling !== form) form.parentNode.insertBefore(el, form);
  }
  function renderShipOut() {
    var s = state.ship, out = $('[data-ship-out]'); if (!out) return;
    var btn = $('[data-ship-check]'); if (btn) { btn.disabled = s.status === 'loading'; btn.textContent = s.status === 'loading' ? '…' : 'Check'; }
    if (s.status === 'loading') { out.innerHTML = '<div class="lsc-ship__msg">Checking rates for ' + esc(s.zip) + '…</div>'; return; }
    if (s.status === 'err') { out.innerHTML = '<div class="lsc-ship__msg lsc-ship__msg--err">' + esc(s.msg) + '</div>'; return; }
    if (s.status !== 'ok') { out.innerHTML = ''; return; }
    if (!s.rates.length) { out.innerHTML = '<div class="lsc-ship__msg">We don\'t have an online rate for ' + esc(s.zip) + ' yet. Contact us and we\'ll quote your shipping.</div>'; return; }
    out.innerHTML = '<ul class="lsc-ship__rates">' + s.rates.map(function (r) {
      return '<li>' + esc(r.name) + ': ' + esc(money(Math.round(parseFloat(r.price) * 100))) + '</li>';
    }).join('') + '</ul><div class="lsc-ship__msg">Rates for ' + esc(s.zip) + ' (' + esc(s.st.name) + '). You\'ll see final shipping and tax at checkout.</div>';
  }
  function rateErrMsg(j, zip) {
    var parts = [];
    if (j && typeof j === 'object') Object.keys(j).forEach(function (k) { var v = j[k]; parts.push(Array.isArray(v) ? v.join(' ') : String(v)); });
    var t = parts.join(' ');
    if (/zip|postal/i.test(t) || /not valid|invalid/i.test(t)) return 'We couldn\'t find ZIP ' + zip + '. Check it and try again.';
    return 'We couldn\'t load shipping rates right now. Please try again, or see rates at checkout.';
  }
  function fetchRates(zip, st) {
    var q = 'shipping_address%5Bzip%5D=' + zip + '&shipping_address%5Bcountry%5D=' + encodeURIComponent('United States') + '&shipping_address%5Bprovince%5D=' + encodeURIComponent(st.name);
    var opts = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    function fail(r) { return r.json().catch(function () { return {}; }).then(function (j) { throw { user: rateErrMsg(j, zip) }; }); }
    function poll(n) {
      return fetch('/cart/async_shipping_rates.json?' + q, opts).then(function (r) {
        if (!r.ok && r.status !== 202) return fail(r);
        return r.text().then(function (t) {
          var j = null; try { j = JSON.parse(t); } catch (e) {}
          if (j && Array.isArray(j.shipping_rates)) return j.shipping_rates;
          if (n >= 24) throw { user: 'Shipping rates are taking longer than usual. Please try again in a moment.' };
          return new Promise(function (res) { setTimeout(res, 500); }).then(function () { return poll(n + 1); });
        });
      });
    }
    return fetch('/cart/prepare_shipping_rates.json?' + q, Object.assign({ method: 'POST' }, opts)).then(function (r) { return r.ok ? poll(0) : fail(r); });
  }
  function runRates(zip, fromUser) {
    var s = state.ship, st = zipState(zip);
    s.zip = zip;
    if (!st) { s.status = 'err'; s.msg = /^\d{5}$/.test(zip) ? 'We couldn\'t find ZIP ' + zip + '. Check it and try again.' : 'Enter a 5-digit ZIP code.'; renderShipOut(); return Promise.resolve(); }
    lsSet(SHIP_LS, zip);
    if (state.cart) renderFreeShipping(state.cart); // Alaska threshold follows the ZIP
    if (fromUser) syncToCold(zip);
    s.st = st; s.status = 'loading'; s.sig = state.cart ? cartSig(state.cart) : ''; var my = ++s.seq;
    renderShipOut(); renderLegal(state.cart);
    return fetchRates(zip, st).then(function (rates) {
      if (my !== s.seq) return;
      s.rates = rates.slice().sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); }); s.status = 'ok'; renderShipOut();
      if (state.cart && cartSig(state.cart) !== s.sig) runRates(zip); // cart changed while loading (e.g. a cold weather level was added)
    }).catch(function (e) {
      if (my !== s.seq) return;
      console.warn('[lsc-cart] shipping rates', e); s.status = 'err'; s.msg = (e && e.user) || 'We couldn\'t load shipping rates right now. Please try again, or see rates at checkout.'; renderShipOut();
    });
  }
  function renderShipLegal(cart) {
    ensureShipUI();
    var s = state.ship, inp = $('[data-ship-zip]');
    if (inp && document.activeElement !== inp && !inp.value) inp.value = s.zip || lsGet(SHIP_LS) || coldZip(cart);
    if (!s.auto) { s.auto = true; var z = lsGet(SHIP_LS); if (!/^\d{5}$/.test(z) && /^\d{5}$/.test(coldZip(cart))) z = coldZip(cart); if (/^\d{5}$/.test(z)) { if (inp && document.activeElement !== inp) inp.value = z; runRates(z); } }
    else if (s.status === 'ok' && s.sig !== cartSig(cart)) runRates(s.zip); // cart changed: refresh the shown rates
    renderShipOut();
    renderLegal(cart);
  }

  /* legality */
  var legalP = null;
  function loadLegal() {
    if (!legalP) legalP = cfg.legalityUrl ? fetch(cfg.legalityUrl, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('legality ' + r.status); return r.json(); }).catch(function (e) { console.warn('[lsc-cart]', e); legalP = null; return null; }) : Promise.resolve(null);
    return legalP;
  }
  function legalPlace(cart) {
    var z = state.ship.zip && zipState(state.ship.zip) ? state.ship.zip : '';
    if (!z) { var lz = lsGet(SHIP_LS); if (zipState(lz)) z = lz; }
    if (z) return { code: zipState(z).code, from: 'ZIP ' + z };
    var cz = coldZip(cart); if (zipState(cz)) return { code: zipState(cz).code, from: 'ZIP ' + cz };
    var pc = String(cfg.customerProvince || '').toUpperCase(); if (US[pc]) return { code: pc, from: 'the address on your account' };
    return null;
  }
  function shortName(t) { return String(t || '').split(' / ')[0].split(' - ')[0].replace(/\s*\((special order|pre-order)\)\s*/ig, ' ').trim(); }
  /* hidden order tag for follow-up (2026-10-09): '_Legality warning' cart attribute mirrors the bar; '' when no bar.
     Writes are serialized and only sent when the value changes; Checkout waits for the latest one (state.legalSync). */
  var LEGAL_ATTR = '_Legality warning';
  function setLegalAttr(cart, val) {
    // compare with the cart as last fetched, so a write lost to a concurrent cart update is redone on the next render
    var cur = (cart && cart.attributes && cart.attributes[LEGAL_ATTR]) || '';
    if (val === state.legalSent && (val === cur || state.legalBusy)) return state.legalAttrP || Promise.resolve();
    state.legalSent = val; state.legalBusy = (state.legalBusy || 0) + 1;
    state.legalAttrP = (state.legalAttrP || Promise.resolve()).catch(function () {}).then(function () { return writeLegalAttr(val); })
      .then(function () { state.legalBusy--; }, function () { state.legalBusy--; });
    return state.legalAttrP;
  }
  function writeLegalAttr(val) {
    var body = { attributes: {} }; body.attributes[LEGAL_ATTR] = val;
    return api('/cart/update.js', body).then(function () { if (state.cart && state.cart.attributes) state.cart.attributes[LEGAL_ATTR] = val; })
      .catch(function (e) { state.legalSent = undefined; console.warn('[lsc-cart] legality attribute', e); });
  }
  function ensureLegalAttr() { // before checkout: wait for pending work, then confirm on the server copy of the cart
    return Promise.resolve(state.legalSync).then(function () { return state.legalAttrP; }).then(function () {
      if (state.legalSent === undefined) return;
      return api('/cart.js').then(function (c) { if (((c.attributes || {})[LEGAL_ATTR] || '') !== state.legalSent) return writeLegalAttr(state.legalSent); });
    }).catch(function () {});
  }
  function renderLegal(cart) {
    state.legalSync = renderLegalInner(cart);
    return state.legalSync;
  }
  function renderLegalInner(cart) {
    var bar = $('[data-lsc-legal]'); if (!bar || !cart) return Promise.resolve();
    var place = legalPlace(cart);
    if (!place) { bar.hidden = true; bar.innerHTML = ''; return setLegalAttr(cart, ''); }
    return loadLegal().then(function (L) {
      if (!L || state.cart !== cart && state.cart) { if (!L) { bar.hidden = true; } return state.legalAttrP; }
      var code = place.code.toLowerCase(), seen = {}, names = [], soft = [], ym = L.ym || LEGAL_YELLOW;
      cart.items.forEach(function (i) {
        if (isManaged(i) || seen[i.product_id]) return;
        var m = L.p && L.p[String(i.product_id)]; if (!m) return;
        var g = L.groups[m.g] || {}, red = m.r || g.r || [], yel = m.y || g.y || [];
        if (red.indexOf(code) > -1 || (ym === 'red' && yel.indexOf(code) > -1)) { seen[i.product_id] = 1; names.push(shortName(i.product_title)); }
        else if (ym === 'note' && yel.indexOf(code) > -1) { seen[i.product_id] = 1; soft.push(shortName(i.product_title)); }
      });
      if (!names.length && !soft.length) { bar.hidden = true; bar.innerHTML = ''; bar.className = 'lsc-legal'; return setLegalAttr(cart, ''); }
      var st = (L.states && L.states[code]) || [US[place.code], '#' + US[place.code].toLowerCase().replace(/\s+/g, '-')];
      function join(ns) {
        var list = ns.map(function (n) { return '<strong>' + esc(n) + '</strong>'; });
        return list.length === 1 ? list[0] : list.length === 2 ? list.join(' and ') : list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
      }
      var link = '<a href="' + esc(L.url + st[1]) + '" target="_blank" rel="noopener">illegal fish by state</a>', html = '';
      if (names.length) html += '<p class="lsc-legal__text">Heads up: ' + (names.length === 1 ? join(names) : 'some fish in your cart (' + join(names) + ')') + ' may be banned or need a permit in ' + esc(st[0]) + '. Check the rule before you order: ' + link + '.' + esc(FEE_TXT.legalAppend) + '</p>';
      // yellow: softer note, informational only (no order hold / no _Legality warning attribute)
      var listLink = '<a href="' + esc(L.url + st[1]) + '" target="_blank" rel="noopener">illegal fish by state list</a>';
      if (soft.length) html += '<p class="lsc-legal__note">' + (names.length
        ? 'The rules in ' + esc(st[0]) + ' may also cover ' + join(soft) + ', and we couldn\'t confirm it either way. Check with your state to be sure.'
        // pending Christian's OK (Phineas, Oct 9). To revert, swap the next line for the previous wording:
        //   : 'Just so you know: ' + esc(st[0]) + '\'s rules may cover ' + join(soft) + ', and we couldn\'t confirm it either way. Check with your state to be sure. Details are in our ' + listLink + '.') + '</p>';
        : 'Just so you know: the rules in ' + esc(st[0]) + ' may cover ' + join(soft) + ', and we couldn\'t confirm it either way. Check with your state to be sure. Each state\'s rules are in our ' + listLink + '.') + '</p>';
      html += '<p class="lsc-legal__from">Based on ' + esc(place.from) + '.</p>';
      bar.innerHTML = html;
      bar.className = 'lsc-legal' + (names.length ? '' : ' lsc-legal--soft');
      bar.setAttribute('role', names.length ? 'alert' : 'status');
      bar.hidden = false;
      // only red states hold the order: the hidden '_Legality warning' attribute (what staff follow up on) lists red fish only
      if (!names.length) return setLegalAttr(cart, '');
      return setLegalAttr(cart, place.code + ': ' + names.join(', ') + ' (' + (/^ZIP /.test(place.from) ? place.from : 'account address') + ')');
    });
  }

  /* cold weather check (same steps as pressing Check in the Cold weather box) */
  function coldRun(zip) {
    return checkZip(zip).then(function (pred) {
      pred.selected = pred.error ? null : (pred.hold ? null : pred.level);
      savePred(pred);
      var predicted = pred.error ? 'Unknown (forecast unavailable)' : pred.hold ? 'Hold - unsafe to ship' : levelName(pred.level);
      var attrs = { 'Shipping ZIP': zip, 'Predicted cold weather level': predicted, 'Forecast ship day': new Date(pred.ship + 'T12:00:00Z').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }) };
      var p = api('/cart/update.js', { attributes: attrs });
      closePop();
      if (pred.selected != null) return p.then(function (c) { state.cart = c; return applyColdSelection(pred.selected); });
      return mutate(p);
    });
  }
  /* ZIP sync (2026-10-09): a ZIP checked in one box fills and checks the other. Only user-initiated checks sync, so there is no loop.
     A box the customer is typing in (focused, holding a different value) is left alone. */
  function typingElsewhere(sel, zip) { var a = document.activeElement; return !!(a && a.matches && a.matches(sel) && a.value && a.value !== zip); }
  function syncToRates(zip) {
    if (typingElsewhere('[data-ship-zip]', zip)) return;
    var inp = $('[data-ship-zip]'); if (inp) inp.value = zip;
    if (state.ship.zip === zip && (state.ship.status === 'ok' || state.ship.status === 'loading')) return;
    runRates(zip);
  }
  function syncToCold(zip) {
    if (typingElsewhere('[data-cw-zip]', zip)) return;
    var pred = loadPred(), attr = state.cart && state.cart.attributes && state.cart.attributes['Shipping ZIP'];
    if (pred && pred.zip === zip && !pred.error && attr === zip) return; // already checked for this ZIP
    var inp = $('[data-cw-zip]'); if (inp) inp.value = zip;
    coldRun(zip);
  }

  /* ---------- open / close ---------- */
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lsc-locked');
    setTimeout(function () { var c = $('.lsc-head__close'); c && c.focus({ preventScroll: true }); }, 50);
    return refresh();
  }
  function close() {
    if (PAGE_MODE) return; // inline cart page never closes
    saveNote(); closePop();
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lsc-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    if (cfg.isCartPage && state.dirtyOnCartPage) window.location.reload();
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-lsc-close]')) { e.preventDefault(); return close(); }
    if (t.closest('[data-lsc-continue]') && !cfg.isCartPage) { e.preventDefault(); return close(); }
    var li = t.closest('.lsc-item');
    if (li && t.closest('[data-qty]')) { var inp = li.querySelector('[data-qty-input]'); return changeLine(li.dataset.key, Math.max(0, (+inp.value || 0) + (+t.closest('[data-qty]').dataset.qty))); }
    if (li && t.closest('[data-remove]')) return changeLine(li.dataset.key, 0);
    if (t.closest('[data-lsc-pop-close]') || t === $('[data-lsc-pop]')) { e.preventDefault(); return closePop(); }
    var pop = t.closest('[data-pop]'); if (pop) { e.preventDefault(); return openPop(pop.dataset.pop); }
    var kq = t.closest('[data-kit-qty]'); if (kq) return kitStep(+kq.dataset.kitQty);
    var dq = t.closest('[data-don-qty]'); if (dq) return donationStep(+dq.dataset.donQty);
    var tg = t.closest('[data-lsc-toggle]');
    if (tg) {
      var panel = $('[data-lsc-panel="' + tg.dataset.lscToggle + '"]'); panel.hidden = !panel.hidden; tg.setAttribute('aria-expanded', String(!panel.hidden));
      if (!panel.hidden) { var f = panel.querySelector('input,textarea'); f && f.focus(); }
      return;
    }
    if (t.closest('[data-lsc-note-save]')) return saveNote();
    var cr = t.closest('[data-code-remove]');
    if (cr) { var keep = (state.cart.discount_codes || []).map(function (c) { return c.code; }).filter(function (c) { return c !== cr.dataset.codeRemove; }); return mutate(setDiscounts(keep)); }
    var nav = t.closest('[data-ups-nav]'); if (nav) { var tr = $('[data-ups-track]'); tr.scrollBy({ left: (+nav.dataset.upsNav) * (tr.clientWidth * 0.8), behavior: 'smooth' }); return; }
    var add = t.closest('[data-ups-add]');
    if (add) {
      var card = add.closest('.lsc-card'), vid = +card.querySelector('[data-ups-variant]').value;
      add.disabled = true; add.textContent = 'Adding…';
      return api('/cart/add.js', { items: [{ id: vid, quantity: 1 }] }).then(function () { add.textContent = 'Added'; add.classList.add('is-added'); if (cfg.isCartPage) state.dirtyOnCartPage = true; return refresh(); })
        .catch(function (err) { add.disabled = false; add.textContent = 'Add to cart'; showErr(err.message); });
    }
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-qty-input]')) return changeLine(t.closest('.lsc-item').dataset.key, Math.max(0, +t.value || 0));
    if (t.matches('[data-addon-toggle]')) return toggleAddon(t.dataset.addonToggle, t.checked);
    if (t.matches('[data-don-input]')) return donationSet(t.value === '' ? 0 : t.value);
    if (t.matches('[data-cw-select]')) { var lv = +t.value; var p = loadPred() || {}; p.selected = lv; savePred(p); return applyColdSelection(lv); }
    if (t.matches('[data-ups-variant]')) { var o = t.options[t.selectedIndex]; t.closest('.lsc-card').querySelector('[data-ups-price]').textContent = money(Math.round(parseFloat(o.dataset.price) * 100)); }
  });
  root.addEventListener('toggle', function (e) { if (e.target.matches && e.target.matches('[data-cw-details]')) state.cwDetailsOpen = e.target.open; }, true);
  root.addEventListener('focusout', function (e) { if (e.target.matches('[data-lsc-note-text]')) saveNote(); });
  root.addEventListener('submit', function (e) {
    var f = e.target;
    if (PREVIEW && f.matches('[data-ship-form]')) { e.preventDefault(); var sz = (f.querySelector('[data-ship-zip]').value || '').trim(); return runRates(sz, true); }
    if (f.matches('[data-cw-form]')) {
      e.preventDefault();
      var zip = (f.querySelector('[data-cw-zip]').value || '').trim(), btn = f.querySelector('[data-cw-check]');
      if (!/^\d{5}$/.test(zip)) { showErr('Please enter a 5-digit ZIP code.'); return; }
      btn.disabled = true; btn.textContent = '…';
      if (PREVIEW) syncToRates(zip); // ZIP sync: fill + check the shipping-rate box too
      return coldRun(zip);
    }
    if (f.matches('[data-lsc-discount-form]')) {
      e.preventDefault();
      var code = (f.discount.value || '').trim(); if (!code) return;
      var msg = $('[data-lsc-discount-msg]'); msg.textContent = '';
      var existing = (state.cart.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
      busy(true);
      return setDiscounts(existing.concat([code])).then(function (c) {
        var hit = (c.discount_codes || []).filter(function (x) { return x.code.toLowerCase() === code.toLowerCase(); })[0];
        if (!c.discount_codes) msg.textContent = 'Your code will be applied at checkout.';
        else if (!hit || !hit.applicable) { msg.textContent = 'That discount code isn\'t valid for this cart.'; return setDiscounts(existing).then(refresh); }
        else { f.discount.value = ''; }
        return refresh();
      }).catch(function () { busy(false); msg.textContent = 'There was an error with your discount code. Please try again later.'; });
    }
    if (f.matches('[data-lsc-checkout-form]')) {
      e.preventDefault();
      // never disable the button (a disabled button survives Safari back/forward cache); guard double taps with a flag instead
      if (state.checkingOut) return;
      state.checkingOut = true; setTimeout(resetCheckout, 8000);
      var gone = false, ta = $('[data-lsc-note-text]');
      var go = function (ok) {
        if (gone) return; gone = true;
        if (ok !== false) { window.location.href = '/checkout'; return; }
        // AJAX note save failed or hung: native POST /cart saves the note and redirects to checkout
        var hid = function (name) { return f.querySelector('input[name="' + name + '"]') || f.appendChild(Object.assign(document.createElement('input'), { type: 'hidden', name: name })); };
        hid('note').value = ta ? ta.value : ''; hid('checkout').value = 'Checkout';
        HTMLFormElement.prototype.submit.call(f);
      };
      setTimeout(function () { go(false); }, 6000);
      // wait for the note save and the latest hidden legality attribute write (bounded by the 6s fallback above)
      var legal = PREVIEW ? ensureLegalAttr() : Promise.resolve();
      Promise.all([saveNote(), legal]).then(function (r) { go(r[0]); }, function () { go(false); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
  root.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('[data-don-input]')) { e.preventDefault(); e.target.blur(); } });
  function resetCheckout() { state.checkingOut = false; var b = $('.lsc-checkout'); if (b) { b.disabled = false; b.removeAttribute('disabled'); } }
  window.addEventListener('pageshow', resetCheckout);

  // add-to-cart forms anywhere on the site -> Ajax add + open drawer
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || root.contains(f)) return;
    var action = f.getAttribute('action') || '';
    if (!/\/cart\/add(\?|$|\.js)/.test(action)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = e.submitter || f.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('disabled', 'disabled');
    api('/cart/add.js', new FormData(f), true).then(function () { open(); })
      .catch(function (err) { open().then(function () { showErr(err.message); }); })
      .then(function () { if (btn) btn.removeAttribute('disabled'); });
  }, true);
  // cart icon / cart links -> open drawer (the /cart page itself keeps the native cart)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || root.contains(a)) return;
    var href = a.getAttribute('href').split('?')[0].replace(/^https?:\/\/[^/]+/, '');
    if (PAGE_MODE) { if (href === '/cart') { e.preventDefault(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } return; }
    if (cfg.isCartPage) return;
    if (href === '/cart' || href === (window.routes && window.routes.cartUrl)) { e.preventDefault(); e.stopImmediatePropagation(); open(); }
  }, true);

  // mount: inline on the full cart page; elsewhere ?lsc_cart=open (set by the /cart handoff) opens the drawer
  if (PAGE_MODE) {
    pageSlot.appendChild(root);
    root.classList.add('lsc-cart--page', 'is-open'); root.setAttribute('aria-hidden', 'false');
    var asideEl = root.querySelector('.lsc-cart__drawer'); if (asideEl) { asideEl.removeAttribute('aria-modal'); asideEl.setAttribute('role', 'region'); }
    refresh();
  } else if (/[?&]lsc_cart=open(&|$)/.test(location.search)) {
    try { var cu = new URL(location.href); cu.searchParams.delete('lsc_cart'); history.replaceState(history.state, '', cu.pathname + cu.search + cu.hash); } catch (e) {}
    open();
  }

  window.LSCCart = { open: open, close: close, refresh: refresh, _predict: predictLevel, _shipDay: shipDay };
  // keep header count consistent with the drawer (add-ons don't count as items)
  fetchCart().then(function (c) { var n = visibleCount(c); document.querySelectorAll('.header__cart-count, [data-cart-count]').forEach(function (el) { el.textContent = n; });
    var es = document.querySelector('.empty-state__description span'); if (es && !c.items.length) { var th = fsThreshold(c); if (th !== (cfg.freeShippingThreshold || 50000)) es.textContent = money(th - c.total_price); } }).catch(function () {});
})();
